import React, { useContext, useEffect, useState, Fragment } from "react";
import "../../../../ui-styles/buttons/RadioButtons.css";
import { LangCtx } from "../../../../lib/context";
import Button from "../../../../lib/ui/buttons/Button";
import { getDoctorSlots, getDateAppointments } from "../../../../actions/appointment";
import Loader from "../../../../lib/ui/loader/Loader";
import { dateFormat, timeFormat } from "../../../../lib/functions";
import NoData from "../../../../lib/ui/nodata/NoData";
import {API} from 'aws-amplify';

const TimeSlots = (props) => {
    const { l } = useContext(LangCtx);
    const [schData, setSchData] = useState([]);
    const [slotData, setSlotData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [aptloading, setaptLoading] = useState(false);
    const [data, setData] = useState({});
    const [error, setError] = useState("");
    const [aptData, setAppoints] = useState([]);
    useEffect(() => {
        if (props.formData && props.formData.startTime && props.formData.endTime) {
            const { formData, id } = props;
            let d = new Date(formData.startTime).getDay();
            setData({ startTime: formData.startTime, endTime: formData.endTime, day: Number(d), slotId: formData.slotId, scheduleId: id });
        } else {
            setData({});
        }
    }, [props.formData]);

    useEffect(() => {
        setLoading(true);
        if (props.id && props.id !== null) {
            getDoctorSlots(props.id)
                .then((res) => {
                    res && res.status ? setSchData([...res.data]) : setSchData([]);
                    // setLoading(false);
                })
                .catch((err) => {
                    console.log("err === ", err);
                    setSchData([]);
                    if(API.isCancel(err)) {
                        console.log("API is canceled................");
                    } else {
                        setLoading(false);
                    }
                });
        } else {
            setSchData([]);
            setLoading(false);
        }
    }, [props.id]);

    useEffect(() => {
        setLoading(true);
        let now = Number(new Date().valueOf());
        let slots = [];
        for (let i = 0; i < schData.length; i++) {
            let _data = { ...schData[i] };
            let slotsList = [];
            // console.log("slots === ", _data.slots, schData);
            for (let j = 0; j < _data.slots.length; j++) {
                let slt = new Date(_data.slots[j]);
                let from = new Date(props.selDate);
                from.setHours(slt.getHours(), slt.getMinutes(), 0, 0);
                // from.setMinutes(slt.getMinutes())
                // from.setHours(Math.floor(slt / 60), slt % 60, 0, 0);
                // from.setHours(Math.floor(slt / 60));
                // from.setMinutes(slt % 60);
                // from.setSeconds(0);
                // console.log("from ==== ", from);
                // console.log("slt ==== ", slt);
                // console.log("Math.floor(slt / 60) ===== ", Math.floor(slt / 60));
                // console.log("slt % 60 ===== ", slt % 60);
                let to = new Date(from);
                to.setMinutes(from.getMinutes() + _data.duration);
                // to.setSeconds(0);
                Number(from.valueOf()) >= now && slotsList.push({ startTime: from.valueOf(), endTime: to.valueOf() });
            }
            _data.slots = [...slotsList];
            slots.push(_data);
        }
        // console.log("enter ==== ", props.selDate, slots, schData, props.id);
        setSlotData([...slots]);
        setLoading(false);
    }, [props.selDate, schData]);

    useEffect(() => {
        setaptLoading(true);
        if (props.selDate && props.doctorId && props.doctorId !==null){
        getDateAppointments(props.selDate, props.doctorId)
            .then((res) => {
                setaptLoading(false);
                res && res.status && res.data.length > 0 ? setAppoints([...res.data]) : setAppoints([]);
            })
            .catch((err) => {
                console.log("err ==== ", err);
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setaptLoading(false);
                }
                setAppoints([]);
            });
        }
    }, [props.selDate, props.doctorId]);

    const handleNext = () => {
        data && data.startTime ? props.handleNext(data, "VR") : setError(l.pls_sel_slot);
    };
    // console.log("aptData ==== ", aptData, slotData);
    const checkReleaseSlot = (paymentStatus, createdAt, appt_status, endTime) => {
        let now = new Date();
        now.setMinutes(now.getMinutes() - 5);
        // release slot conditions
        if (paymentStatus === "paid" && (appt_status === "cancelled" || appt_status === "rejected")) {
            return false;
        }
        if (paymentStatus !== "paid" && createdAt <= now.valueOf() && endTime <= now.valueOf()) {
            return false;
        }
        //block slot
        return true;
    };
    const displaySlots = () => {
        let slots_list = [];

        for (let i in slotData) {
            let _data = slotData[i];
            for (let j in _data.slots) {
                let slt = _data.slots[j];
                let s_v =
                    aptData.findIndex(
                        (itm) => slt.startTime === itm.startTime && checkReleaseSlot(itm.paymentStatus, itm.createdAt, itm.appt_status, itm.endTime)
                    ) === -1 ? (
                        <Fragment>
                            <input
                                id={slt.startTime}
                                name="slot"
                                type="radio"
                                value={slt.startTime}
                                onChange={(e) =>
                                    setData({
                                        startTime: Number(slt.startTime),
                                        endTime: Number(slt.endTime),
                                        day: Number(new Date(slt.startTime).getDay()),
                                        slotId: _data.slotId,
                                        scheduleId: props.id,
                                    })
                                }
                                checked={data && data.startTime && data.startTime === Number(slt.startTime)}
                            />
                            <label htmlFor={slt.startTime}>
                                {timeFormat(slt.startTime)} - {timeFormat(slt.endTime)}
                            </label>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <input id={slt.startTime} name="slot" type="radio" disabled />
                            <label htmlFor={slt.startTime}>
                                {timeFormat(slt.startTime)} - {timeFormat(slt.endTime)}
                            </label>
                        </Fragment>
                    );
                slots_list.push(
                    <div className="radioInputGroup width25" key={slt.startTime}>
                        {s_v}
                    </div>
                );
            }
        }
        if (slots_list.length > 0) {
            return slots_list;
        } else {
            return <NoData Heading={l.no_schedules} src="/images/icons/no-schedule-new.png" label="" />;
        }
    };
    return (
        <>
        {(loading || aptloading) && <Loader />}
        <div className={props.active === "TS" ? "baColBlock firstChild firstChildSlide" : "baColBlock firstChild"}>
            <div className="formContainer">
                <div className="rowBlock">
                    <div className="formHdngBlock">
                        {/* <span>{l.today}, 7 September, 2020.</span> */}
                        <span>{dateFormat(props.selDate)}</span>
                        {!loading && !aptloading && <small>{slotData.length === 0 ? l.no_timeslot_desc : l.timeslot_desc} </small>}
                        {error && error !== "" && <span className="redTxt errorTxt">{error}</span>}
                    </div>
                    {slotData.length > 0 && data && data.startTime && (
                        <div className="pTxtFlx childRight">
                            <Button size="md" className="btn" type="primary" onClick={handleNext} label={l.next} />
                        </div>
                    )}
                </div>

                <form className="form">
                    {slotData.length > 0
                        ? displaySlots()
                        : !loading && !aptloading && <NoData Heading={l.no_slots} src="/images/icons/no-schedule-new.png" label="" />}
                </form>
            </div>
            {slotData.length > 0 && data && data.startTime && (
                <div className="baFtrGtnGroup">
                    <div></div>
                    <Button size="md" className="btn" type="primary" onClick={handleNext} label={l.next} />
                </div>
            )}
        </div>
        </>
    );
};
export default TimeSlots;

//     slotData.map(_data => {
//         if (_data.slots.length > 0) {
//             return _data.slots.map(slt => <div className="radioInputGroup width25" key={slt.startTime}>
//     {aptData.findIndex(itm => slt.startTime === itm.startTime) === -1 ? <Fragment>
//         <input id={slt.startTime} name="slot" type="radio" value={slt.startTime} onChange={(e) => setData({ startTime: Number(slt.startTime), endTime: Number(slt.endTime), day: Number(new Date(slt.startTime).getDay()), slotId: _data.slotId, scheduleId: props.id })} checked={data && data.startTime && data.startTime === Number(slt.startTime)} />
//         <label htmlFor={slt.startTime}>{timeFormat(slt.startTime)} - {timeFormat(slt.endTime)}</label>
//     </Fragment>
//         : <Fragment>
//             <input id={slt.startTime} name="slot" type="radio" disabled />
//             <label htmlFor={slt.startTime}>{timeFormat(slt.startTime)} - {timeFormat(slt.endTime)}</label>
//         </Fragment>}
// </div>)
//         } else { return null; }
//         // else { return <span key={_data.slotId}> Time Out </span> }
//     })
